import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MathCaptcha from "../../Components/UI/MathCaptcha";
// import "./TankerBooking.css";
import "./UpdateDelivery.css";

const MyBookings = () => {
  const [villa_no, setVillaNo] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resetCaptcha, setResetCaptcha] = useState(false);
  const submittingRef = useRef(false);

  const [toast, setToast] = useState({ show: false, text: "", type: "" });
  const [bookings, setBookings] = useState([]);

  // === Toast helper ===
  const showToast = (type, text, duration = 2000) => {
    setToast({ show: true, type, text });
    setTimeout(() => setToast({ show: false, type: "", text: "" }), duration);
  };


  useEffect(() => {
    if (resetCaptcha) setResetCaptcha(false);
  }, [resetCaptcha]);

  const Required = () => <span style={{ color: "red" }}>*</span>;

  const validateVillaNo = (villa_no) => /^[A-Za-z0-9]+$/.test(villa_no);

  const resetCaptchaAfterError = () => {
    setResetCaptcha(true);
    setIsSubmitting(false);
    submittingRef.current = false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submittingRef.current) return;

    submittingRef.current = true;
    setIsSubmitting(true);

    const trimmedVilla = villa_no.trim();

    // Validation
    if (!trimmedVilla) {
      showToast(
        "error",
        "Please enter your Villa/Plot number (कृपया विला नंबर भरें)"
      );
      return resetCaptchaAfterError();
    }

    if (!validateVillaNo(trimmedVilla)) {
      showToast(
        "error",
        "Invalid Villa/Plot No. (Only letters/numbers allowed)"
      );
      return resetCaptchaAfterError();
    }

    if (!isVerified) {
      showToast("error", "Please complete the captcha.");
      return resetCaptchaAfterError();
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/villa_wise_bookings.php`,
        { villa_no: trimmedVilla }
      );

      if (response.status === 200 && response.data.status === "success") {
        setBookings(response.data.data);
        showToast("success", `Found ${response.data.count} bookings.`);
      } else {
        setBookings([]);
        showToast("error", response.data.message || "No data found.");
      }
    } catch (err) {
      setBookings([]);
      const errorMessage =
        err.response?.data?.message || "Something went wrong, try again later.";
      showToast("error", errorMessage);
    } finally {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setResetCaptcha(true);
      setTimeout(() => {
        submittingRef.current = false;
        setIsSubmitting(false);
      }, 1200);
    }
  };

  return (
    <div className="container">
      {/* Toast Notification */}
      {toast.show && (
        <div className={`toast-message toast-${toast.type}`}>{toast.text}</div>
      )}

      <div className="admin-wrap">
        <div className="box-head">
          <span>My Bookings (मेरी जल बुकिंग)</span>
        </div>

        {/* FORM */}
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label
              htmlFor="villa_no"
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Villa/Plot No. (विला/प्लॉट नंबर)
              <Required />
            </label>
            <input
              id="villa_no"
              type="text"
              name="villa_no"
              placeholder="Enter Villa / Plot No"
              value={villa_no}
              onChange={(e) => setVillaNo(e.target.value.toUpperCase())}
              disabled={isSubmitting}
              required
            />
          </div>

          <div className="form-group" style={{ marginBottom: "8px" }}>
            <MathCaptcha onVerification={setIsVerified} reset={resetCaptcha} />
          </div>

          <div style={{ textAlign: "center" }}>
            <button
              type="submit"
              className="readMoreButton"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Fetching..." : "Fetch My Bookings"}
            </button>
          </div>
        </form>
      </div>

      {/* RESULTS TABLE */}
      {bookings.length > 0 && (
        <div className="admin-wrap">
          <div className="box-head" style={{ marginBottom: "5px" }}>
            <span>Bookings for the Villa/ Plot No. {villa_no}</span>
          </div>
          <table className="bookings-table">
            <thead>
              <tr>
                <th>Booked By</th>
                <th>Booking Date</th>
                <th>Scheduled Delivery</th>
                <th>Status</th>
                <th>Delivered On</th>
                <th>Remarks</th>
                <th>Last Delivery</th>
              </tr>
            </thead>
            <tbody>
              {bookings.map((b, index) => (
                <tr key={index}>
                  <td data-label="Booked By">{b.Booked_By}</td>
                  <td data-label="Booking Date">{b.Booking_Date}</td>
                  <td data-label="Scheduled Delivery">
                    {b.Scheduled_Delivery_Date}
                  </td>
                  <td data-label="Status">{b.Delivery_Status}</td>
                  <td data-label="Delivered On">{b.Delivered_On}</td>
                  <td data-label="Remarks">{b.Remarks}</td>
                  <td data-label="Last Delivery">{b.Last_Delivery_Date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* No data case */}
      {bookings.length === 0 && !isSubmitting && (
        <p style={{ textAlign: "center", marginTop: "20px", color: "#777" }}>
          No bookings found. (कोई बुकिंग नहीं मिली)
        </p>
      )}
    </div>
  );
};

export default MyBookings;
